// export const msalConfig = {
//   auth: {
//     clientId: import.meta.env.D,
//     authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID}`,
//     redirectUri: "http://localhost:5173/auth/callback"
//   }
// };

// export const loginRequest = {
//   scopes: ["openid", "profile", "email"]
// };

const DEV_AZURE_CLIENT_ID = "a4eb90b6-7d33-41fd-89c7-25b0ff7c5b9d";
const DEFAULT_AZURE_AUTHORITY = "https://login.microsoftonline.com/common";

const AZURE_CLIENT_ID =
  process.env.REACT_APP_AZURE_CLIENT_ID ||
  process.env.VITE_AZURE_CLIENT_ID ||
  DEV_AZURE_CLIENT_ID;
const AZURE_AUTHORITY =
  process.env.REACT_APP_AZURE_AUTHORITY ||
  process.env.VITE_AZURE_AUTHORITY ||
  DEFAULT_AZURE_AUTHORITY;
const REDIRECT_URI =
  process.env.REACT_APP_AZURE_REDIRECT_URI ||
  process.env.VITE_AZURE_REDIRECT_URI ||
  (typeof window !== "undefined" ? `${window.location.origin}/auth/callback` : "https://echo.atlantisworld.co/auth/callback");
  // (typeof window !== "undefined" ? `${window.location.origin}/auth/callback` : "http://localhost:3001/auth/callback");

if (!process.env.REACT_APP_AZURE_CLIENT_ID) {
  console.warn(
    "Azure AD client id is not set. Using the development fallback client id."
  );
}

export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: AZURE_AUTHORITY.replace(/\/$/, ""),
    redirectUri: REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};



export const loginRequest = {
  scopes: ["openid", "profile", "email"],
  prompt: "select_account",
};
